
export const environment = {
  production: true,
  gafBaseUrl: 'https://www.freelancer.com',
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
  },
  datastoreConfig: {
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    webSocketUrl: 'https://notifications.freelancer.com'
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
    gitRevision: '425b66ab2e6',
    buildDate: 'Tue May 30 2017 22:39:13 GMT-0400 (EDT)'
  },
  billingConfig: {
    baseUrl: 'https://api.flnbln.net',
  },
  facebookAppId: '',
  languageCookie: 'GETAFREE_LANGUAGE'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts